export enum NotesStatus {
    Complete = 1,
    PartiallyComplete = 2,
    Incomplete = 3
  }